import type { HttpBackendOptions } from 'i18next-http-backend';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

const DEFAULT_NS = import.meta.env.VITE_I18N_DEFAULT_NS;
const NAMESPACES = import.meta.env.VITE_I18N_NAMESPACES.split(',');

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init<HttpBackendOptions>({
    debug: import.meta.env.DEV,
    defaultNS: DEFAULT_NS,
    ns: NAMESPACES,
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    // React escapes text children; i18next escaping leaks entities such as
    // `&#x2F;`, `&#39;`, `&amp;` into printed output.
    interpolation: { escapeValue: false },
  });

export default i18n;
